import request from '@/utils/request'

// 党建工会
// 学习强国 Party_building/learningPower
export function learningPower(data) {
  return request({
    method: 'get',
    url: 'Party_building/learningPower',
    params: data
  })
}

// 先锋示范 Party_building/pioneerDemonstration
export function pioneerDemonstration(data) {
    return request({
      method: 'get',
      url: 'Party_building/pioneerDemonstration',
      params: data
    })
  }

// 党建活动 Party_building/partyBuildingActivities

export function partyBuildingActivities(data) {
    return request({
      method: 'get',
      url: 'Party_building/partyBuildingActivities',
      params: data
    })
  }

// 工会活动 Party_building/tradeUnionActivities
export function tradeUnionActivities(data) {
    return request({
      method: 'get',
      url: 'Party_building/tradeUnionActivities',
      params: data
    })
  }







// WEBPACK FOOTER //
// ./src/api/PartyBuilding.js